import { AnyAction } from 'redux';
import { GetQuoteChartDto, GetQuoteDto, GetQuoteListDto, GetQuoteListResponseDto } from 'src/dtos';
import { GetQuoteChartResponse } from 'src/models';

import { createAction, State, Type } from './utils';

// new quote actions
export const doGetQuoteList = (payload: GetQuoteListDto): AnyAction =>
  createAction(State.actionRequested(Type.GET_QUOTE_LIST), payload);

export const doSucceededGetQuoteList = (payload: GetQuoteListResponseDto): AnyAction =>
  createAction(State.actionSucceeded(Type.GET_QUOTE_LIST), payload);

export const doFailedGetQuoteList = (payload: any): AnyAction =>
  createAction(State.actionFailed(Type.GET_QUOTE_LIST), payload);

export const doClearGetQuoteList = (): AnyAction => createAction(State.actionCleared(Type.GET_QUOTE_LIST));

export const doGetQuote = (payload: GetQuoteDto): AnyAction =>
  createAction(State.actionRequested(Type.GET_QUOTE), payload);

export const doSucceededGetQuote = (payload: any): AnyAction =>
  createAction(State.actionSucceeded(Type.GET_QUOTE), payload);

export const doFailedGetQuote = (payload: any): AnyAction => createAction(State.actionFailed(Type.GET_QUOTE), payload);

export const doClearGetQuote = (): AnyAction => createAction(State.actionCleared(Type.GET_QUOTE));

export const doGetQuoteChart = (payload: GetQuoteChartDto): AnyAction =>
  createAction(State.actionRequested(Type.GET_QUOTE_CHART), payload);

export const doSucceededGetQuoteChart = (payload: GetQuoteChartResponse): AnyAction =>
  createAction(State.actionSucceeded(Type.GET_QUOTE_CHART), payload);

export const doFailedGetQuoteChart = (payload: any): AnyAction =>
  createAction(State.actionFailed(Type.GET_QUOTE_CHART), payload);

export const doClearGetQuoteChart = (): AnyAction => createAction(State.actionCleared(Type.GET_QUOTE_CHART));
